import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 6,
    marginLeft: 12,
  },
  tableList: {
    marginTop: 12,
    marginBottom: 6,
  },
  dashboardButton: {
    //float: 'right',
    marginTop: 6,
    marginBottom: 6,
    marginRight: 12,
    //width: '99%',
  },
}));

export default useStyles;
